/**
 * Add a URL parameter (or modify if already exists)
 * @param {String} url
 * @param {String} param
 * @param {String} value
 */
export const addOrReplaceParam = (url: string, param: string, value: string) => {
  // eslint-disable-next-line no-param-reassign
  param = encodeURIComponent(param);
  const r = `([&?]|&amp;)${param}\\b(?:=(?:[^&#]*))*`;
  const a = document.createElement('a');
  const regex = new RegExp(r);
  const str = param + (value ? `=${encodeURIComponent(value)}` : '');
  a.href = url;
  const q = a.search.replace(regex, `$1${str}`);
  if (q === a.search) {
    a.search += (a.search ? '&' : '') + str;
  } else {
    a.search = q;
  }
  return a.href;
};